import { isFiniteNumber, parseStringRecord, StringRecord } from "./storageValidation";

const LISTEN_COUNTS_KEY = "kanalearn.kanjiListenCounts.v1";
export type KanjiListenCounts = StringRecord<number>;

export function getListenCounts(): KanjiListenCounts {
    try {
        const raw = localStorage.getItem(LISTEN_COUNTS_KEY);
        return parseStringRecord(raw, isFiniteNumber);
    } catch {
        return {};
    }
}

export function setListenCounts(counts: KanjiListenCounts): void {
    try {
        localStorage.setItem(LISTEN_COUNTS_KEY, JSON.stringify(counts));
    } catch {
        // Best-effort: if storage is unavailable, counts just won't persist.
    }
}
